import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./theme/ThemeProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import OrgAdminProtectedRoute from "./components/OrgAdminProtectedRoute";
import OrgAdminLayout from "./components/layout/OrgAdminLayout";
import PageSuspenseFallback from "./components/PageSuspenseFallback";

// Pages - Eager load auth pages (immediate access needed)
import OTPLogin from "./pages/OTPLogin";
import ForceResetPassword from "./pages/ForceResetPassword";
import ChangePassword from "./pages/ChangePassword";

// Pages - Lazy load application pages (code splitting)
const ClientManagementPage = React.lazy(() => import("./pages/ClientManagementPage"));
const MonitoringDashboard = React.lazy(() => import("./pages/MonitoringDashboard"));

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <React.Suspense fallback={<PageSuspenseFallback />}>
            <Routes>
            {/* Public routes */}
            <Route path="/login" element={<OTPLogin />} />
            <Route path="/force-reset-password" element={<ForceResetPassword />} />
            <Route path="/change-password" element={<ChangePassword />} />

            {/* Protected admin routes */}
            <Route element={<OrgAdminProtectedRoute />}>
              <Route element={<OrgAdminLayout />}>
                <Route path="/" element={<ClientManagementPage />} />
                <Route path="/clients" element={<ClientManagementPage />} />
                <Route path="/monitoring" element={<MonitoringDashboard />} />
              </Route>
            </Route>

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </React.Suspense>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
